import { cj } from 'src/utils/classNames';

const GRID_COMMON_CLASSNAME = 'grid gap-lg';

const PERP_GRID_TEMPLATE_COLS_CLASSNAME =
	'grid-cols-[minmax(160px,2fr)_minmax(70px,1fr)_minmax(60px,1fr)] sm:grid-cols-[188px_70px_70px_74px_93px_108px]';

const SPOT_GRID_TEMPLATE_COLS_CLASSNAME =
	'grid-cols-[minmax(160px,2fr)_minmax(70px,1fr)_minmax(60px,1fr)] sm:grid-cols-[188px_76px_76px_74px_93px_90px]';

export const getGridClasses = (isPerp: boolean) => {
	const gridTemplateColsClass = isPerp
		? PERP_GRID_TEMPLATE_COLS_CLASSNAME
		: SPOT_GRID_TEMPLATE_COLS_CLASSNAME;

	return cj(GRID_COMMON_CLASSNAME, gridTemplateColsClass);
};
